import React from "react";
import Types from "prop-types";
import LanguageSelector from "../LanguageSelector";
import { ReCaptcha, fetchReCaptchaToken } from "../Guard";
import { withTranslation } from "react-i18next";
import axios from "axios";
import { Redirect } from "react-router-dom";

const passwordPolicy = [
  [new RegExp("^(?=.*[0-9]).*$"), "validation_no_number"],
  [new RegExp("^(?=.*[a-z]).*$"), "validation_no_lower"],
  [new RegExp("^(?=.*[A-Z]).*$"), "validation_no_upper"],
  [new RegExp("^(?=\\S+$).*$"), "validation_spaces"],
  [new RegExp("^.{8,}$"), "validation_length"],
];

class NewPassword extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      password: "",
      error: null,
      showPassword: false,
      isPasswordChanged: false,
    };
    this.passwordRef = null;
  }

  validator(value) {
    const err = passwordPolicy.find(([regexp, error]) => !regexp.test(value));
    if (err) {
      return { message: err[1] };
    }
    return null;
  }

  onSubmit(event) {
    event.preventDefault();
    const token = this.props.match.params.token;

    const { password } = this.state;
    const endpoint = `${process.env.REACT_APP_IDENTITY_SERVICES_SAG_HOST}/recovery/password`;

    const validationError = this.validator(password);

    if (validationError) {
      this.setState({ error: validationError });
      return;
    }

    this.setState({ submitting: true, error: null });

    let recaptchaPromise = fetchReCaptchaToken("forgot_password_email");

    recaptchaPromise
      .then((recaptchaToken) =>
        axios.put(endpoint, { token, password, recaptchaToken })
      )
      .then((res) => res.data)
      .then((res) => this.setState({ isPasswordChanged: true }))
      .catch((err) =>
        this.setState({ submitting: false, error: err.response.data })
      );
  }

  onChange(event) {
    this.setState({ password: event.target.value });
  }

  onToogleChange({ target }) {
    this.setState({ showPassword: target.checked });
  }

  componentDidMount() {
    document.title = "Reset password | Careem";
  }

  render() {
    const { t } = this.props;
    const { error, submitting, isPasswordChanged } = this.state;

    if (isPasswordChanged) {
      return <Redirect to="/password_success" />;
    }

    return (
      <form onSubmit={this.onSubmit.bind(this)}>
        <LanguageSelector />
        <h1>{t("reset_password:enter_new_password")}</h1>
        {error && (
          <div className="invalid show">
            {t(["error:" + error.message, "error:default"])}
          </div>
        )}

        <div className="material-form-field ">
          <input
            className="password-field"
            type={this.state.showPassword ? "input" : "password"}
            autoComplete="off"
            spellCheck="false"
            id="newPassword"
            name="newPassword"
            onChange={this.onChange.bind(this)}
            required
            ref={(ref) => (this.passwordRef = ref)}
          />
          <label className="material-form-field-label" htmlFor="newPassword">
            {t("reset_password:new_password")}
          </label>
        </div>

        <label className="reset-password-label" htmlFor="show-password-toggle">
          <input
            type="checkbox"
            id="show-password-toggle"
            onChange={this.onToogleChange.bind(this)}
          />
          <span>&nbsp;{t("reset_password:show_password")}</span>
        </label>

        <div className="material-form-field password-hint">
          {t("reset_password:strong_password_info")}
        </div>

        <input
          className="btn-careem"
          type="submit"
          value={submitting ? t("common:please_wait") : t("common:continue")}
          name="reset-pass-submit"
          disabled={submitting}
        />

        <ReCaptcha />
      </form>
    );
  }
}

NewPassword.propTypes = {
  t: Types.func.isRequired,
};

export default withTranslation()(NewPassword);
